// extracted by css-extract-rspack-plugin
export default {"label":"Label_label__CJfiX"};